// Translations file for the application
// Contains translations for English, French, and Arabic

const translations = {
  en: {
    // Navbar
    sport: "Sport",
    live: "Live",
    casino: "Casino",
    liveCasino: "Live Casino",
    virtualGames: "Virtual Games",
    promotion: "Promotion",
    login: "Login",
    signUp: "Sign Up",

    // Sports Page
    signUpAndGetReward: "SIGN UP & GET REWARD",
    upTo: "UP TO",
    createAccount: "Create Account",
    allGames: "All Games",
    topRatedGames: "Top Rated Games",
    football: "Football",

    // Casino section
    casinoDescription: "Dive in to our wide range of in-house games, live casino and slots to experience a thrilling casino adventure.",

    // Sports section
    sportDescription: "Dive in to our wide range of in-house games, live casino and slots to experience a thrilling casino adventure.",

    // Footer and other common elements
    allRightsReserved: "All Rights Reserved",
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    contactUs: "Contact Us",
    about: "About",
    aboutUs: "About Us",
    responsibleGaming: "Responsible Gaming",
    affiliate: "Affiliate",
    help: "Help",
    faq: "FAQ",
    regulations: "Regulations",
    generalTermsAndConditions: "General Terms and Conditions",
    amlKycPolicy: "AML & KYC Policy",
    social: "Social",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    copyright: "Copyright"
  },

  fr: {
    // Navbar
    sport: "Sport",
    live: "En Direct",
    casino: "Casino",
    liveCasino: "Casino en Direct",
    virtualGames: "Jeux Virtuels",
    promotion: "Promotion",
    login: "Connexion",
    signUp: "S'inscrire",

    // Sports Page
    signUpAndGetReward: "INSCRIVEZ-VOUS ET OBTENEZ UNE RÉCOMPENSE",
    upTo: "JUSQU'À",
    createAccount: "Créer un Compte",
    allGames: "Tous les Jeux",
    topRatedGames: "Jeux les Mieux Notés",
    football: "Football",

    // Casino section
    casinoDescription: "Plongez dans notre large gamme de jeux maison, casino en direct et machines à sous pour vivre une aventure de casino palpitante.",

    // Sports section
    sportDescription: "Plongez dans notre large gamme de jeux maison, casino en direct et machines à sous pour vivre une aventure de casino palpitante.",

    // Footer and other common elements
    allRightsReserved: "Tous Droits Réservés",
    termsAndConditions: "Termes et Conditions",
    privacyPolicy: "Politique de Confidentialité",
    contactUs: "Contactez-nous",
    about: "À Propos",
    aboutUs: "À Propos de Nous",
    responsibleGaming: "Jeu Responsable",
    affiliate: "Affilié",
    help: "Aide",
    faq: "FAQ",
    regulations: "Règlements",
    generalTermsAndConditions: "Conditions Générales",
    amlKycPolicy: "Politique AML & KYC",
    social: "Social",
    facebook: "Facebook",
    twitter: "Twitter",
    instagram: "Instagram",
    copyright: "Droits d'auteur"
  },

  ar: {
    // Navbar
    sport: "رياضة",
    live: "مباشر",
    casino: "كازينو",
    liveCasino: "كازينو مباشر",
    virtualGames: "ألعاب افتراضية",
    promotion: "عروض",
    login: "تسجيل الدخول",
    signUp: "إنشاء حساب",

    // Sports Page
    signUpAndGetReward: "سجل واحصل على مكافأة",
    upTo: "يصل إلى",
    createAccount: "إنشاء حساب",
    allGames: "جميع الألعاب",
    topRatedGames: "الألعاب الأعلى تقييماً",
    football: "كرة القدم",

    // Casino section
    casinoDescription: "انغمس في مجموعتنا الواسعة من الألعاب الداخلية والكازينو المباشر وآلات القمار لتجربة مغامرة كازينو مثيرة.",

    // Sports section
    sportDescription: "انغمس في مجموعتنا الواسعة من الألعاب الداخلية والكازينو المباشر وآلات القمار لتجربة مغامرة كازينو مثيرة.",

    // Footer and other common elements
    allRightsReserved: "جميع الحقوق محفوظة",
    termsAndConditions: "الشروط والأحكام",
    privacyPolicy: "سياسة الخصوصية",
    contactUs: "اتصل بنا",
    about: "حول",
    aboutUs: "من نحن",
    responsibleGaming: "اللعب المسؤول",
    affiliate: "الشركاء",
    help: "المساعدة",
    faq: "الأسئلة الشائعة",
    regulations: "اللوائح",
    generalTermsAndConditions: "الشروط والأحكام العامة",
    amlKycPolicy: "سياسة مكافحة غسل الأموال والتعرف على العملاء",
    social: "التواصل الاجتماعي",
    facebook: "فيسبوك",
    twitter: "تويتر",
    instagram: "انستغرام",
    copyright: "حقوق النشر"
  }
};

export default translations;
